import {
    GlobalCXContext,
    GlobalCXContextValue
} from '~/components/ClientExperience/providers/global-context/global-cx.context';
import { useGlobal } from '~/providers/global.provider';

export function useGlobalCX(): GlobalCXContextValue {
    return useGlobal<GlobalCXContext>(GlobalCXContext);
}
